import { CommonResponse } from '@/models/common/response';
import request from '@/utils/request';

export async function createLoginQRCode(){
  const response = await request.post(`/api/v1/wechat/create_qrcode`, {});
  return response;
}

export async function checkScanResult(key){
  const response = await request.post(`/api/v1/wechat/checkScanResult`, {
    key
  });
  return response;
}

// 创建微信绑定二维码
export async function createBindQRCode(){
  const response = await request.post(`/api/v1/wechat/create_bind_qrcode`, {});
  return response;
}

// 检查微信绑定结果
export async function checkBindResult(key){
  const response = await request.post(`/api/v1/wechat/checkBindResult`, {
    key
  });
  return response;
}

